export default __webpack_public_path__ + "static/media/time.be542a01.svg";